import validate from "/build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/build/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}